import { NetworkService } from '../../../../services/networkService';

const getOtp = async (id, values, otpFor) => {
  let response = await NetworkService.get(`api/users/${id}/otp?mobile_number=${values}`);
  return response;
};

export default getOtp;
